module.exports = __webpack_public_path__ + "img/Strelica_position_zelena_levo.33da48b7.svg";